import type { IconProps } from '@fabric-app/icons/icons';
import type { FC } from 'react';

const CloseIcon: FC<IconProps> = ({ color = 'currentColor', size = 18, className, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        x="18.4204"
        y="16.9492"
        width="2"
        height="16"
        rx="1"
        transform="rotate(135 18.4204 16.9492)"
        fill={color}
      />
      <rect
        x="7.10693"
        y="18.3633"
        width="2"
        height="16"
        rx="1"
        transform="rotate(-135 7.10693 18.3633)"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
